import { render, staticRenderFns } from "./FeeTypeTree.vue?vue&type=template&id=bbe54ec2&scoped=true"
import script from "./FeeTypeTree.vue?vue&type=script&lang=js"
export * from "./FeeTypeTree.vue?vue&type=script&lang=js"
import style0 from "./FeeTypeTree.vue?vue&type=style&index=0&id=bbe54ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe54ec2",
  null
  
)

export default component.exports